import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInput from "../../../components/forms/CommonInput";
import CommonQuillEditor from "../../../components/forms/CommonQuillEditor";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function NovoTicketModal({ ticketModalHook, valuesHook, salvaNovoTicket }) {
  const { novoTicketModal, setNovoTicketModal } = ticketModalHook;
  const { values, setValues } = valuesHook;
  const modulos = useTipos("modulos");

  return (
    <CommonModal
      title="Novo ticket"
      is_open_modal={novoTicketModal}
      set_is_open_modal={setNovoTicketModal}
      size="lg"
      buttons={[
        <button
          key={`salvar-ticket`}
          type="button"
          onClick={() => {
            salvaNovoTicket();
          }}
          className="btn btn-success"
        >
          Salvar
        </button>,
      ]}
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonSelect
            label="Módulo"
            id="modulo"
            value={values.modulo}
            onChange={(e) => handleChange(e, values, setValues)}
            data={modulos.map((modulo) => ({
              text: modulo.valor,
              id: modulo.chave,
            }))}
            placeholder="Selecione o módulo"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 mb-3">
          <CommonInput
            label="Título"
            id="titulo"
            value={values.titulo}
            onChange={(e) => handleChange(e, values, setValues)}
            maxlength="100"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 mb-3">
          <CommonQuillEditor
            label="Texto"
            id="texto"
            value={values.texto}
            onChange={(html) =>
              handleChangeNameValue("texto", html, values, setValues)
            }
          />
        </div>
      </div>
    </CommonModal>
  );
}

NovoTicketModal.propTypes = {
  ticketModalHook: PropTypes.shape({
    novoTicketModal: PropTypes.bool.isRequired,
    setNovoTicketModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaNovoTicket: PropTypes.func.isRequired,
};

export default NovoTicketModal;
